var $ = jQuery;
var MigrationProgressModel = require( './MigrationProgress-model' );
var MigrationProgressView = require( './MigrationProgress-view' );
var $overlayOriginal = $( '<div id="overlay" class="hide"></div>' );
var $progressContentOriginal = $( '.progress-content' ).clone().addClass( 'hide' );
var $proVersion = $( '.pro-version' ).addClass( 'hide' );

$overlayOriginal.append( $proVersion );

var MigrationProgressController = {
	migration: {
		model: {},
		view: {},
		$progress: {},
		$wrapper: {},
		$overlay: {},
		status: 'active',
		title: '',
		text: '',
		timerCount: 0,
		timerStart: 0,
		elapsedInterval: 0,
		currentStageNum: 0,
		counterDisplay: false,
		originalTitle: document.title,
		setTitle: function( title ) {
			this.$progress.find( '.progress-title' ).html( title );
			this.title = title;
		},
		setStatus: function( status ) {
			this.$progress
				.removeClass( this.status )
				.addClass( ( 'error' === status ) ? 'wpmdb-error' : status );

			// Possible statuses include: 'error', 'paused', 'complete', 'cancelling'
			if ( 'error' === status ) {
				this.$progress.find( '.progress-text' ).addClass( 'migration-error' );
			}

			this.status = status;

			this.updateTitleElem();
		},
		setText: function( text ) {
			if ( 'string' !== typeof text ) {
				text = '';
			}

			if ( 0 >= text.indexOf( 'wpmdb_error' ) ) {
				text = this.decodeErrorObject( text );
			}

			this.$progress.find( '.progress-text' ).html( text );
			this.text = text;
		},
		setState: function( title, text, status ) {
			if ( null !== title ) {
				this.setTitle( title );
			}
			if ( null !== text ) {
				this.setText( text );
			}
			if ( null !== status ) {
				this.setStatus( status );
			}
		},
		startTimer: function() {
			this.timerStart = Date.now();
			this.timerCount = 0;
			this.counterDisplay = $( '.timer' );
			this.elapsedInterval = setInterval( this.incrementTimer.bind( this ), 1000 );
		},
		getTimerCountInSeconds() {
			return Math.floor( (Date.now() - this.timerStart) / 1000 );
		},
		pauseTimer: function() {
			this.pausedAt = Date.now()
			clearInterval( this.elapsedInterval );
		},
		resumeTimer: function() {
			this.timerStart += Date.now() - this.pausedAt;
			this.elapsedInterval = setInterval( this.incrementTimer.bind( this ), 1000 );
		},
		incrementTimer: function() {
			this.timerCount = this.getTimerCountInSeconds();
			this.displayCount();
		},
		displayCount: function() {
			var hours = Math.floor( this.timerCount / 3600 ) % 24;
			var minutes = Math.floor( this.timerCount / 60 ) % 60;
			var seconds = this.timerCount % 60;
			var display = this.pad( hours, 2, 0 ) + ':' + this.pad( minutes, 2, 0 ) + ':' + this.pad( seconds, 2, 0 );
			this.counterDisplay.html( display );
		},
		updateTitleElem: function() {
			var activeStage = this.model.get( 'activeStageName' );
			var stageModel = this.model.getStageModel( activeStage );
			var percentDone = Math.max( 0, stageModel.getTotalProgressPercent() );
			var numStages = this.model.get( 'stages' ).length;
			var currentStage = this.currentStageNum;
			var currentStatus = this.status;
			var progressText = wpmdb_strings.title_progress;

			if ( 'complete' === stageModel.get( 'status' ) && 0 === stageModel.get( 'totalSize' ) ) {
				percentDone = 100;
			}

			progressText = progressText.replace( '%1$s', percentDone + '%' );
			progressText = progressText.replace( '%2$s', currentStage );
			progressText = progressText.replace( '%3$s', numStages );

			if ( 1 === numStages ) {
				progressText = percentDone + '%';
			}

			if ( wpmdb_strings[ 'title_' + currentStatus ] ) {
				progressText = wpmdb_strings[ 'title_' + currentStatus ];
			}

			progressText = progressText + ' - ' + this.originalTitle;

			document.title = progressText;
		},
		restoreTitleElem: function() {
			document.title = this.originalTitle;
		},
		pad: function( num, width, padChar ) {
			padChar = padChar || '0';
			num = num + '';
			return num.length >= width ? num : new Array( width - num.length + 1 ).join( padChar ) + num;
		},

		// fixes error objects that have been mangled by html encoding
		decodeErrorObject: function( input ) {
			var inputDecoded = input
				.replace( /\{&quot;/g, '{#q!#' )
				.replace( /\&quot;}/g, '#q!#}' )
				.replace( /,&quot;/g, ',#q!#' )
				.replace( /&quot;:/g, '#q!#:' )
				.replace( /:&quot;/g, ':#q!#' )
				.replace( /&quot;/g, '\\"' )
				.replace( /#q!#/g, '"' )
				.replace( /&gt;/g, '>' )
				.replace( /&lt;/g, '<' );
			try {
				inputDecoded = JSON.parse( inputDecoded );
			} catch ( e ) {
				return input;
			}
			return ( 'object' === typeof inputDecoded && 'undefined' !== typeof inputDecoded.body ) ? inputDecoded : input;
		},
		fixProgressStageWidthForScrollBar: function() {
			var scrollBarWidth = Math.abs( this.$wrapper[0].offsetWidth - this.$wrapper[0].clientWidth );
			var visibleProgressItems = this.$wrapper.find( '.active .progress-items' );
			var leftPad = parseInt( visibleProgressItems.css( 'padding-left' ), 10 );
			var rightPad = parseInt( visibleProgressItems.css( 'padding-right' ), 10 );

			if ( 0 !== scrollBarWidth ||  ( 0 === scrollBarWidth && rightPad !== leftPad ) ) {
				visibleProgressItems.css( 'padding-right', leftPad - scrollBarWidth + 'px' );
			}
		}
	},
	newMigration: function( settings ) {
		$( '#overlay' ).remove();
		$( '.progress-content' ).remove();
		this.migration.$overlay = $overlayOriginal.clone();

		$( '#wpwrap' ).append( this.migration.$overlay );

		this.migration.model = new MigrationProgressModel( settings );
		this.migration.view = new MigrationProgressView( {
			model: this.migration.model
		} );

		this.migration.$progress = $progressContentOriginal.clone();
		this.migration.$wrapper = this.migration.view.$el;
		this.migration.$progress.find( '.migration-progress-stages' ).replaceWith( this.migration.$wrapper );

		this.migration.$proVersion = this.migration.$overlay.find( '.pro-version' );
		var proVersionIFrame = this.migration.$proVersion.find( 'iframe' ).remove().clone();

		this.migration.$overlay.prepend( this.migration.$progress );

		// timeout needed so class is added after elements are appended to dom and transition runs.
		var self = this;
		setTimeout( function() {
			self.migration.$overlay.add( self.migration.$progress ).add( self.migration.$proVersion ).removeClass( 'hide' ).addClass( 'show' );
			if ( self.migration.$proVersion.length ) {
				setTimeout( function() {
					self.migration.$proVersion.find( '.iframe' ).append( proVersionIFrame );
				}, 500 );
			}
		}, 0 );

		this.migration.currentStageNum = 0;

		this.migration.$proVersion.on( 'click', '.close-pro-version', function() {
			self.migration.$proVersion.find( 'iframe' ).remove();
			self.migration.$proVersion.addClass( 'hide remove' );
			setTimeout( function() {
				self.migration.$proVersion.remove();
			}, 500 );
		} );

		this.migration.model.on( 'migrationComplete', function() {
			self.utils.updateProgTableVisibilitySetting();
			self.utils.updatePauseBeforeFinalizeSetting();
			self.migration.pauseTimer();
		} );

		$( window ).on( 'resize', _.debounce( this.migration.fixProgressStageWidthForScrollBar.bind( this.migration ), 100 ) );
		this.migration.model.on( 'change:activeStage', this.migration.fixProgressStageWidthForScrollBar.bind( this.migration ) );

		return this.migration;
	},
	utils: require( './MigrationProgress-utils' )
};

module.exports = MigrationProgressController;



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/modules/MigrationProgress-controller.js